import {
  CaseReportDatePlaceBox,
  CaseReportDatePlaceContainer,
} from './CaseReportDatePlace.styles';
import * as React from 'react';
import { BodyText, CaseReportSectionTitle } from 'src/components/atomsLegacy';

export interface CaseReportDatePlaceProps {
  date: string;
  time: string;
  location: string;
  'data-testid'?: string;
}

export const CaseReportDatePlace: React.FC<CaseReportDatePlaceProps> = ({
  date,
  time,
  location,
  ...props
}) => {
  let dateText = '—';
  if (date) {
    if (time) {
      dateText = `${date} ${time}`;
    } else {
      dateText = date;
    }
  }

  return (
    <CaseReportDatePlaceContainer data-testid={props['data-testid']}>
      <CaseReportSectionTitle>{'Event Detail'}</CaseReportSectionTitle>
      <CaseReportDatePlaceBox>
        <BodyText weight="regular" size="small" margin="0">
          Date: {dateText}
        </BodyText>
        <BodyText weight="regular" size="small" margin="0">
          Place: {location}
        </BodyText>
      </CaseReportDatePlaceBox>
    </CaseReportDatePlaceContainer>
  );
};
